// Kampanya pop-up'ı (2026-10-20): oturum başına 1 kez gösterilir, 1,2 sn sonra açılır.
// Anahtar snippets/promo-popup.liquid'deki data-popup-key'den gelir; görsel değişince anahtar da değişir
// ve pop-up herkese yeniden gösterilir. Kapatma: çarpı, karartma alanına tıklama veya Esc.
(function () {
  function initPromoPopup() {
    var overlay = document.getElementById('promo-popup-overlay');
    if (!overlay) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var key = overlay.getAttribute('data-popup-key') || 'promoPopupShown';
    try {
      if (window.sessionStorage.getItem(key)) return;
    } catch (e) {}

    var img = overlay.querySelector('img');

    function markShown() {
      try {
        window.sessionStorage.setItem(key, '1');
      } catch (e) {}
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') hidePopup();
    }

    function reveal() {
      window.requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
      });
    }

    function showPopup() {
      overlay.style.display = 'flex';
      markShown();
      document.addEventListener('keydown', onKey);
      if (!img || (img.complete && img.naturalWidth > 0)) {
        reveal();
      } else {
        img.addEventListener('load', reveal, { once: true });
        img.addEventListener('error', hidePopup, { once: true });
      }
    }

    function hidePopup() {
      overlay.classList.remove('is-visible');
      document.removeEventListener('keydown', onKey);
      window.setTimeout(function () {
        overlay.style.display = 'none';
      }, 260);
    }

    var closeBtn = overlay.querySelector('.promo-popup__close');
    if (closeBtn) closeBtn.addEventListener('click', hidePopup);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) hidePopup();
    });

    window.setTimeout(showPopup, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoPopup);
  } else {
    initPromoPopup();
  }
})();
